import React from "react";
import "./Modal.css";

const Modal = (props) => {

 console.log(props)
  return (
    <React.Fragment>
      <div className="backdrop"/>
      <div className="modal"  onPointerDown={props.hide}>
        
        <div className="modal-menu">
          <div className="modal-menu-header">geTimer</div>
          <div className="modal-menu-item" onPointerDown={props.delete}>DELETE</div>
          {/* <div className="modal-menu-item" onPointerDown={props.penalty}>T+2s</div>
          <div className="modal-menu-item" onPointerDown={props.dnf}>DNF</div> */}
          <div className="modal-menu-item" onPointerDown={props.puz2}>2x2</div>
          <div className="modal-menu-item" onPointerDown={props.puz3}>3x3</div>
          <div className="modal-menu-item" onPointerDown={props.reset}>RESET</div>
          <div className="modal-menu-item" onPointerDown={props.hide}>CANCEL</div>
        </div>
        <div className="desktop-info">
        <ul>
          <li>
            <b>Desktop shortcuts</b>
          </li>
          <li>[space]: start/stop</li>
          <li>[del]: delete most recent time</li>
          <li>[2]: 2x2 puzzle</li>
          <li>[3]: 3x3 puzzle</li>
          <li>[r]: reset session (delete all times)</li>
          <li>[h]: hide/unhide timer</li>
        </ul>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Modal; //used by Identity.js
